"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemHighlight = exports.ResellerInfoWrapper = exports.EdgeButtonWrapper = exports.Wrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const flora_react_1 = require("@grupoboticario/flora-react");
exports.Wrapper = (0, flora_react_1.styled)(flora_react_1.Box, {
    width: '100%',
    boxSizing: 'border-box',
    background: '$backgroundSecondary',
    overflow: 'hidden',
    padding: '0',
});
const EdgeButtonWrapper = ({ children }) => ((0, jsx_runtime_1.jsx)(flora_react_1.Box, Object.assign({ css: { minWidth: 60 } }, { children: children })));
exports.EdgeButtonWrapper = EdgeButtonWrapper;
const ResellerInfoWrapper = ({ size, children, }) => (0, jsx_runtime_1.jsx)(flora_react_1.Box, Object.assign({ css: { maxWidth: size === 'mobile' ? 200 : 260 } }, { children: children }));
exports.ResellerInfoWrapper = ResellerInfoWrapper;
exports.ItemHighlight = (0, flora_react_1.styled)(flora_react_1.Box, {
    variants: {
        anchor: {
            left: {
                borderRadius: '0px 8px 0px 0px',
                paddingRight: 16,
                '@desktop': {
                    paddingRight: 32,
                },
            },
            center: {
                borderRadius: '8px 8px 0px 0px',
            },
            right: {
                borderRadius: '8px 0px 0px 0px',
                paddingLeft: 16,
                '@desktop': {
                    paddingLeft: 32,
                },
            },
        },
        selected: {
            true: {
                backgroundColor: '$backgroundPrimary',
                boxShadow: '0px -4px 20px rgba(0, 0, 0, 0.12)',
            },
        },
    },
});
